import { authService } from './auth-service';

/**
 * Initiates the OAuth2 flow by redirecting to the authorization URL
 */
export async function startOAuthFlow(): Promise<void> {
  try {
    const redirectUrl = await authService.getAuthorizationUrl();
    
    // Store the current location to redirect back after auth
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath !== '/signin' && currentPath !== '/oauth/callback') {
      sessionStorage.setItem('oauth_redirect', currentPath);
    }

    // Redirect to the OAuth provider
    window.location.href = redirectUrl;
  } catch (error) {
    console.error('Failed to start OAuth flow:', error);
    throw error;
  }
}

/**
 * Handles the OAuth callback with the authorization code
 */
export async function handleOAuthCallback(code: string, state: string): Promise<void> {
  try {
    await authService.exchangeCode(code, state);

    // Get the redirect path if it was stored
    const redirectPath = sessionStorage.getItem('oauth_redirect');
    sessionStorage.removeItem('oauth_redirect');

    // Redirect to the stored path or home
    window.location.href = redirectPath || '/';
  } catch (error) {
    console.error('Failed to handle OAuth callback:', error);
    throw error;
  }
}

/**
 * Parse the OAuth callback parameters from URL
 */
export function parseOAuthCallback(): { code: string; state: string } | null {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');

  if (!code || !state) {
    return null;
  }

  return { code, state };
}

